/**
 * #4733 (APIWALL, #2894): pages whose route requires is_admin as well as the
 * page grant. Every API such a page loads is admin-only on the server
 * (requireAdminMiddleware), so a non-admin whose role row lists the page, and
 * who reaches it by a typed URL or a bookmark, could only watch its reads
 * fail. AppShell shows them the Admin page's own refusal instead of mounting
 * the page, and the #4586 dark sweep reads this same list: the page never
 * mounts for a non-admin, so it sends nothing. The menu already hides each of
 * these from non-admins (the catalog's adminOnly).
 */
export const ADMIN_ROUTE_PAGES: readonly string[] = ["/admin/ai-feedback"];

/** True for an ADMIN_ROUTE_PAGES page or a route under it (the conversation view). */
export function isAdminRoutePage(path: string): boolean {
  return ADMIN_ROUTE_PAGES.some((page) => path === page || path.startsWith(`${page}/`));
}

/**
 * #4733 round 4: pages whose own component refuses a non-admin before it
 * sends any read: Admin.tsx returns AdminOnlyNotice on `!is_admin` before a
 * tab or section mounts. Exact paths, read by the #4586 dark sweep only (the
 * page itself is the guard). Not every /admin page: Material Mapping and
 * Ostendo Access mount and read for anyone their page grant lets in, so a
 * refused read there is a real 403 and stays swept.
 */
export const ADMIN_ONLY_IN_PAGE: readonly string[] = ["/admin"];

/** True when a non-admin never sends this page's reads: an admin route, or a page that refuses them itself. */
export function isAdminOnlyPage(page: string): boolean {
  return isAdminRoutePage(page) || ADMIN_ONLY_IN_PAGE.includes(page);
}
